/* Sitewide field-kit progress. Reads thresholds and eligible products from the live
   bundle-builder page, so the header never has a separate hardcoded tier table. */
(() => {
  const bar = document.querySelector('[data-global-kit]');
  if (!bar) return;
  const url = bar.dataset.builderUrl;
  const root = window.MudjugConfig?.root || '/';
  let config = null;
  let lastCart = null;
  const itemNode = bar.querySelector('[data-global-kit-count]');
  const messageNode = bar.querySelector('[data-global-kit-message]');
  const meterNode = bar.querySelector('[data-global-kit-meter]');
  const stepsNode = bar.querySelector('[data-global-kit-steps]');
  const stateNode = bar.querySelector('[data-global-kit-status]');
  const nextRewardMessage = (tiers, count) => {
    const rewards = tiers.filter(t => /free.*lid|free.*stealth|free shipping/i.test(`${t.label} ${t.description}`));
    const next = rewards.find(t => count < t.threshold);
    if (!next) return 'All field kit milestones unlocked!';
    const combined = `${next.label} ${next.description}`;
    const name = /free.*lid/i.test(combined) ? 'your FREE Dip Can Lid' : /free.*stealth/i.test(combined) ? 'your FREE Basic Stealth' : 'FREE standard shipping';
    const remaining = next.threshold-count;
    return `Add ${remaining} more Mudjug${remaining===1?'':'s'} to unlock ${name}`;
  };
const getCollectionEligible = async (builder) => {
    const handle = builder?.dataset.eligibleCollection;
    if (!handle || handle === 'all') return new Set();
    const ids = new Set([...builder.querySelectorAll('[data-bundle-product]')].map(node => String(node.dataset.productId)).filter(Boolean));
    for (let page = 1; page <= 100; page++) {
      const res = await fetch(`${root}collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`, { credentials: 'same-origin' });
      if (!res.ok) { if (ids.size) return ids; throw new Error('Unable to load eligible Mudjug collection'); }
      const products = (await res.json()).products || [];
      products.forEach(p => ids.add(String(p.id)));
      if (products.length < 250) return ids;
    }
    return ids;
  };
  const getEligible = (cart) => (cart?.items || []).filter(item => {
    const props = item.properties || {};
    if (Object.keys(props).some(key => key.toLowerCase().includes('mudjug_reward_candidate'))) return false;
    return (config?.eligible?.has(String(item.product_id)) ?? false);
  });
  const render = () => {
    if (!lastCart) return;
    const quantity = getEligible(lastCart).reduce((n, item) => n + item.quantity, 0);
    itemNode.textContent = `${quantity} ${quantity === 1 ? 'MUDJUG' : 'MUDJUGS'}`;
    if (!config || !config.tiers.length) {
      messageNode.textContent = 'Build your field kit and unlock milestones';
      stateNode.textContent = 'VIEW KIT';
      meterNode.style.width = '0%';
      stepsNode.replaceChildren();
      return;
    }
    const tiers = config.tiers;
    const next = tiers.find(t => quantity < t.threshold);
    const last = tiers[tiers.length - 1];
    // Use the same cumulative 0-to-final-milestone scale as the slide cart
    // and product-page Field Kit widgets. Completed milestones never reset fill.
    const percent = Math.max(0, Math.min(100, (quantity / Math.max(1, last.threshold)) * 100));
    meterNode.style.width = `${percent}%`;
    meterNode.setAttribute('aria-valuemin', '0');
    meterNode.setAttribute('aria-valuemax', String(last.threshold));
    meterNode.setAttribute('aria-valuenow', String(Math.min(quantity, last.threshold)));
    if (next) {
      const remaining = next.threshold - quantity;
      messageNode.textContent = nextRewardMessage(tiers, quantity);
      stateNode.textContent = `${quantity} / ${next.threshold}`;
    } else {
      messageNode.textContent = nextRewardMessage(tiers, quantity);
      stateNode.textContent = `${quantity} MUDJUGS`;
    }
    stepsNode.replaceChildren();
    tiers.forEach(t => {
      const chip = document.createElement('span');
      chip.className = `global-kit__tier${quantity >= t.threshold ? ' is-unlocked' : ''}${next === t ? ' is-next' : ''}`;
      chip.textContent = quantity >= t.threshold ? '✓' : String(t.threshold);
      chip.title = `${t.threshold} Mudjugs: ${t.label}${t.description ? ` — ${t.description}` : ''}`;
      chip.setAttribute('aria-label', `${t.label}: ${quantity >= t.threshold ? 'unlocked' : `${t.threshold - quantity} to go`}`);
      stepsNode.append(chip);
    });
  };
  const loadCart = async () => {
    try {
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
      if (!response.ok) return;
      lastCart = await response.json();
      render();
    } catch (_) {}
  };
  const loadConfig = async () => {
    try {
      const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const builder = html.querySelector('[data-bundle-builder]');
      if (!builder) return;
      const tiers = [...builder.querySelectorAll('[data-bundle-milestone]')].map(node => ({
        threshold: Number(node.dataset.threshold),
        label: node.querySelector('.bundle-milestone__copy strong')?.textContent?.trim() || 'Field kit milestone',
        description: node.querySelector('.bundle-milestone__copy > span')?.textContent?.trim() || ''
      })).filter(t => Number.isFinite(t.threshold) && t.threshold > 0).sort((a, b) => a.threshold - b.threshold);
      const eligible = await getCollectionEligible(builder);
      config = { tiers, eligible };
      render();
    } catch (_) { /* No invented tiers when page cannot be read. */ }
  };
  document.addEventListener('mudjug:cart-updated', event => { lastCart = event.detail; render(); });
  document.addEventListener('shopify:section:load', () => { loadConfig(); loadCart(); });
  document.addEventListener('cart:updated', loadCart);
  document.addEventListener('cart:refresh', loadCart);
  window.addEventListener('pageshow', () => { loadCart(); });
  loadConfig();
  loadCart();
})();
